module.exports = __webpack_public_path__ + "img/icn-timer.45bd0294.svg";